/**
 * @generated SignedSource<<62d9b71d51469ea2734afb4fddd649c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSprintBacklogWrapper_Query$variables = {
  projectId?: string | null;
  groupId?: string | null;
  fetchLazyData: boolean;
  personId: string;
};
export type ProjectSprintBacklogWrapper_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly project: {
      readonly id: string;
    } | null;
    readonly projectGroup: {
      readonly projects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectSprintBacklogWrapper_viewer">;
  } | null;
};
export type ProjectSprintBacklogWrapper_Query = {
  variables: ProjectSprintBacklogWrapper_Query$variables;
  response: ProjectSprintBacklogWrapper_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchLazyData"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_sprint_backlog_wrapper_v4"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"project_sprint_backlog_wrapper_v4\")"
},
v6 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "groupId"
  }
],
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "kind": "Variable",
  "name": "personId",
  "variableName": "personId"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingAutoCalculated",
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "approvedOnly",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "backlog",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "context",
    "value": "sprint"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  },
  {
    "kind": "Literal",
    "name": "simpleResponse",
    "value": true
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskReadOnly",
  "kind": "LinkedField",
  "name": "readOnly",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isReadOnly",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanDeleteTask",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCantDeleteTaskReason",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNovaConversation",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v32 = {
  "condition": "fetchLazyData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": (v27/*: any*/),
      "concreteType": "TimeRegTypeConnection",
      "kind": "LinkedField",
      "name": "timeRegistrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRegTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v7/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Role",
                      "kind": "LinkedField",
                      "name": "role",
                      "plural": false,
                      "selections": (v8/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v28/*: any*/)
              ],
              "storageKey": null
            },
            (v29/*: any*/)
          ],
          "storageKey": null
        },
        (v30/*: any*/)
      ],
      "storageKey": "timeRegistrations(first:10000)"
    },
    {
      "alias": null,
      "args": (v27/*: any*/),
      "filters": ([]/*: any*/),
      "handle": "connection",
      "key": "Task_timeRegistrations",
      "kind": "LinkedHandle",
      "name": "timeRegistrations"
    },
    (v31/*: any*/)
  ]
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDependency",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canStart",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBeSetToDone",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTaskCount",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLockedTime",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvoicedTime",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskLabel",
  "kind": "LinkedField",
  "name": "taskLabels",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "label",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v13/*: any*/),
        (v55/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v13/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/)
  ],
  "storageKey": null
},
v62 = [
  (v7/*: any*/),
  (v13/*: any*/)
],
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskDismissedNotifications",
  "kind": "LinkedField",
  "name": "taskDismissedNotifications",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskOverrunPredictionDismissed",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demo",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": [
    (v12/*: any*/)
  ],
  "concreteType": "ProjectPerson",
  "kind": "LinkedField",
  "name": "projectPerson",
  "plural": false,
  "selections": [
    (v63/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    (v7/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profile",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskHierarchy",
  "storageKey": null
},
v84 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v85 = [
  (v84/*: any*/)
],
v86 = {
  "alias": null,
  "args": (v85/*: any*/),
  "concreteType": "DependencyTypeConnection",
  "kind": "LinkedField",
  "name": "thisTaskDependsOn",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DependencyTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DependencyType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "thisDependsOnTask",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v13/*: any*/),
                (v37/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/),
                (v40/*: any*/),
                (v41/*: any*/),
                (v42/*: any*/)
              ],
              "storageKey": null
            },
            (v28/*: any*/)
          ],
          "storageKey": null
        },
        (v29/*: any*/)
      ],
      "storageKey": null
    },
    (v30/*: any*/)
  ],
  "storageKey": "thisTaskDependsOn(first:1000)"
},
v87 = {
  "alias": null,
  "args": (v85/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "Task_thisTaskDependsOn",
  "kind": "LinkedHandle",
  "name": "thisTaskDependsOn"
},
v88 = [
  (v7/*: any*/),
  (v69/*: any*/)
],
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v88/*: any*/),
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": (v88/*: any*/),
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "parentTask",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskProgress",
  "kind": "LinkedField",
  "name": "progressDetails",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": (v15/*: any*/),
  "filters": [
    "backlog"
  ],
  "handle": "connection",
  "key": "Project_tasks",
  "kind": "LinkedHandle",
  "name": "tasks"
},
v94 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v64/*: any*/),
                (v69/*: any*/),
                (v65/*: any*/),
                (v66/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "initials",
                  "storageKey": null
                },
                (v67/*: any*/),
                (v68/*: any*/),
                (v63/*: any*/),
                (v70/*: any*/)
              ],
              "storageKey": null
            },
            (v63/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectPersons(first:1000000)"
},
v95 = {
  "condition": "fetchLazyData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v21/*: any*/)
  ]
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "savedPerformance",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnfinishedTask",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "SprintIntegrationsType",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adoId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": (v85/*: any*/),
  "concreteType": "PhaseTypeConnection",
  "kind": "LinkedField",
  "name": "phases",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhaseType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v62/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "phases(first:1000)"
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "StatusColumnV2TypeConnection",
  "kind": "LinkedField",
  "name": "statusColumnsV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2TypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatusColumnV2",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "order",
              "storageKey": null
            },
            (v13/*: any*/),
            (v100/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jiraStatusId",
              "storageKey": null
            },
            (v60/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "statusColumnsV2(first:1000000)"
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupSprintId",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProjectGroupSprint",
  "storageKey": null
},
v106 = [
  (v84/*: any*/),
  {
    "kind": "Literal",
    "name": "onlyProjectGroupSprints",
    "value": true
  }
],
v107 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSprintBacklogWrapper_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(first:1000000)"
              }
            ],
            "storageKey": null
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchLazyData",
                "variableName": "fetchLazyData"
              },
              {
                "kind": "Variable",
                "name": "groupId",
                "variableName": "groupId"
              },
              (v12/*: any*/),
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ProjectSprintBacklogWrapper_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectSprintBacklogWrapper_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": (v15/*: any*/),
                "concreteType": "TaskTypeConnection",
                "kind": "LinkedField",
                "name": "tasks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v13/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v56/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v59/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "statusColumnV2",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v13/*: any*/),
                              (v60/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v61/*: any*/),
                          (v63/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "assignedPersons",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v64/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              },
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v69/*: any*/),
                              (v70/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v71/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v13/*: any*/),
                              (v72/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Client",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v62/*: any*/),
                                "storageKey": null
                              },
                              (v73/*: any*/),
                              (v74/*: any*/),
                              (v14/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              (v77/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectStartYear",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectStartMonth",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectStartDay",
                                "storageKey": null
                              },
                              (v78/*: any*/),
                              (v79/*: any*/),
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v83/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v86/*: any*/),
                          (v87/*: any*/),
                          (v89/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/),
                          (v92/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v30/*: any*/)
                ],
                "storageKey": "tasks(approvedOnly:true,backlog:true,context:\"sprint\",first:100000,simpleResponse:true)"
              },
              (v93/*: any*/),
              (v94/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "SprintTypeConnection",
                "kind": "LinkedField",
                "name": "sprints",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SprintTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Sprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v13/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecast",
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          (v41/*: any*/),
                          (v40/*: any*/),
                          (v59/*: any*/),
                          (v58/*: any*/),
                          (v57/*: any*/),
                          (v95/*: any*/),
                          (v96/*: any*/),
                          (v97/*: any*/),
                          {
                            "alias": null,
                            "args": (v11/*: any*/),
                            "concreteType": "SprintPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "sprintPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SprintPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SprintPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "condition": "fetchLazyData",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "availableMinutes",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "scheduledMinutes",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "taskAvailableMinutes",
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v65/*: any*/),
                                          (v66/*: any*/),
                                          (v67/*: any*/),
                                          (v68/*: any*/),
                                          (v63/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "sprintPersons(first:1000000)"
                          },
                          (v98/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v30/*: any*/)
                ],
                "storageKey": "sprints(first:1000000)"
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_sprints",
                "kind": "LinkedHandle",
                "name": "sprints"
              },
              (v99/*: any*/),
              (v101/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v13/*: any*/),
                          (v72/*: any*/),
                          (v82/*: any*/),
                          (v75/*: any*/),
                          (v102/*: any*/),
                          (v81/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "taskLevels",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sprintTimeBox",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sprintLengthInDays",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "useManualAllocations",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          (v76/*: any*/),
                          (v77/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualProgressOnProjectEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualProgressOnPhasesEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualProgressOnTasksEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "budgetWork",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "budgetType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "concreteType": "TaskTypeConnection",
                            "kind": "LinkedField",
                            "name": "tasks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Task",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v20/*: any*/),
                                      (v19/*: any*/),
                                      (v13/*: any*/),
                                      (v21/*: any*/),
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/),
                                      (v35/*: any*/),
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v40/*: any*/),
                                      (v41/*: any*/),
                                      (v42/*: any*/),
                                      (v43/*: any*/),
                                      (v44/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v47/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v51/*: any*/),
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v54/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectType",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v72/*: any*/),
                                          (v76/*: any*/),
                                          (v77/*: any*/),
                                          (v75/*: any*/),
                                          (v13/*: any*/),
                                          (v102/*: any*/),
                                          (v81/*: any*/),
                                          (v78/*: any*/),
                                          (v79/*: any*/),
                                          (v80/*: any*/),
                                          (v14/*: any*/),
                                          (v82/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "projectGroupId",
                                            "storageKey": null
                                          },
                                          (v74/*: any*/),
                                          (v73/*: any*/),
                                          (v70/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RateCard",
                                            "kind": "LinkedField",
                                            "name": "rateCard",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v103/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Role",
                                                "kind": "LinkedField",
                                                "name": "disabledRoles",
                                                "plural": true,
                                                "selections": (v8/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v83/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v56/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Sprint",
                                        "kind": "LinkedField",
                                        "name": "sprint",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v57/*: any*/),
                                          (v58/*: any*/),
                                          (v59/*: any*/),
                                          (v96/*: any*/),
                                          (v13/*: any*/),
                                          (v104/*: any*/),
                                          (v105/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StatusColumnV2",
                                        "kind": "LinkedField",
                                        "name": "statusColumnV2",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v13/*: any*/),
                                          (v60/*: any*/),
                                          (v100/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v61/*: any*/),
                                      (v63/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "assignedPersons",
                                        "plural": true,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v64/*: any*/),
                                          (v65/*: any*/),
                                          (v66/*: any*/),
                                          (v67/*: any*/),
                                          (v68/*: any*/),
                                          (v69/*: any*/),
                                          (v70/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v71/*: any*/),
                                      (v86/*: any*/),
                                      (v87/*: any*/),
                                      (v89/*: any*/),
                                      (v90/*: any*/),
                                      (v91/*: any*/),
                                      (v92/*: any*/),
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v30/*: any*/)
                            ],
                            "storageKey": "tasks(approvedOnly:true,backlog:true,context:\"sprint\",first:100000,simpleResponse:true)"
                          },
                          (v93/*: any*/),
                          (v94/*: any*/),
                          {
                            "alias": null,
                            "args": (v106/*: any*/),
                            "concreteType": "SprintTypeConnection",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SprintTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v13/*: any*/),
                                      (v104/*: any*/),
                                      (v105/*: any*/),
                                      (v42/*: any*/),
                                      (v41/*: any*/),
                                      (v40/*: any*/),
                                      (v59/*: any*/),
                                      (v58/*: any*/),
                                      (v57/*: any*/),
                                      (v95/*: any*/),
                                      (v96/*: any*/),
                                      (v97/*: any*/),
                                      (v98/*: any*/),
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v30/*: any*/)
                            ],
                            "storageKey": "sprints(first:1000,onlyProjectGroupSprints:true)"
                          },
                          {
                            "alias": null,
                            "args": (v106/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "Project_sprints",
                            "kind": "LinkedHandle",
                            "name": "sprints"
                          },
                          (v99/*: any*/),
                          (v101/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(first:1000000)"
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectGroupId",
                "storageKey": null
              },
              (v13/*: any*/),
              (v55/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraServerEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraCloud",
                    "plural": false,
                    "selections": (v107/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraServer",
                    "plural": false,
                    "selections": (v107/*: any*/),
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backendId",
                "storageKey": null
              },
              (v13/*: any*/),
              (v103/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingProjectAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v62/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(first:1000000)"
              },
              {
                "alias": null,
                "args": [
                  (v10/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "labelType",
                    "value": "TASK"
                  }
                ],
                "concreteType": "LabelTypeConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v13/*: any*/),
                          (v55/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v62/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "labels(first:1000000,labelType:\"TASK\")"
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "ClientTypeConnection",
                "kind": "LinkedField",
                "name": "clients",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "logoId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "logoDefaultId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "clients(first:1000000)"
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": (v11/*: any*/),
                            "concreteType": "TeamPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "teamPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": (v8/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "teamPersons(first:1000000)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "teams(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sunday",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5eaf1331809949a384d75d0a9de21dec",
    "id": null,
    "metadata": {},
    "name": "ProjectSprintBacklogWrapper_Query",
    "operationKind": "query",
    "text": "query ProjectSprintBacklogWrapper_Query(\n  $projectId: ID\n  $groupId: String\n  $fetchLazyData: Boolean!\n  $personId: ID!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"project_sprint_backlog_wrapper_v4\")\n    project(internalId: $projectId) {\n      id\n    }\n    projectGroup(id: $groupId) {\n      projects(first: 1000000) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      id\n    }\n    ...ProjectSprintBacklogWrapper_viewer_1PXsLa\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment LabelDropdownJS_labels on Label {\n  color\n  name\n  id\n  category {\n    id\n    name\n  }\n}\n\nfragment ProjectSprintBacklogWrapper_viewer_1PXsLa on Viewer {\n  id\n  language\n  actualPersonId\n  availableFeatureFlags {\n    key\n    id\n  }\n  projectGroup(id: $groupId) {\n    id\n    companyProjectGroupId\n    name\n    color\n    projects(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          demo\n          stage {\n            __typename\n            id\n            name\n            profile\n          }\n          companyProjectId\n          ...DeprecatedProjectIndicatorJS_project\n          taskLevels\n          sprintTimeBox\n          sprintLengthInDays\n          useManualAllocations\n          remainingAutoCalculated\n          projectColor\n          estimationUnit\n          minutesPerEstimationPoint\n          manualProgressOnProjectEnabled\n          manualProgressOnPhasesEnabled\n          manualProgressOnTasksEnabled\n          budgetWork\n          budgetType\n          tasks(first: 100000, approvedOnly: true, simpleResponse: true, backlog: true, context: \"sprint\") {\n            edges {\n              node {\n                id\n                readOnly {\n                  isReadOnly\n                  id\n                }\n                userCanDeleteTask\n                userCantDeleteTaskReason\n                sageIntacctId\n                hasChildren\n                name\n                description\n                highPriority\n                companyTaskId\n                hasNovaConversation\n                estimateForecast\n                timeLeft @include(if: $fetchLazyData)\n                timeRegistrations(first: 10000) @include(if: $fetchLazyData) {\n                  edges {\n                    node {\n                      id\n                      minutesRegistered\n                      invoiced\n                      person {\n                        id\n                        role {\n                          id\n                        }\n                      }\n                      __typename\n                    }\n                    cursor\n                  }\n                  pageInfo {\n                    endCursor\n                    hasNextPage\n                  }\n                }\n                progress @include(if: $fetchLazyData)\n                approved\n                sortOrder\n                blocked\n                bug\n                deadlineYear\n                deadlineMonth\n                deadlineDay\n                startYear\n                startMonth\n                startDay\n                startFrom\n                deadlineFrom\n                hasDependency\n                canStart\n                canBeSetToDone\n                subTaskCount\n                latestUiUpdateAt\n                hasLockedTime\n                hasInvoicedTime\n                favoured\n                billable\n                parentTaskId\n                project {\n                  id\n                  demo\n                  estimationUnit\n                  minutesPerEstimationPoint\n                  companyProjectId\n                  ...DeprecatedProjectIndicatorJS_project\n                  projectEndYear\n                  projectEndMonth\n                  projectEndDay\n                  projectColor\n                  remainingAutoCalculated\n                  name\n                  stage {\n                    __typename\n                    id\n                    name\n                    profile\n                  }\n                  projectGroupId\n                  projectPerson(personId: $personId) {\n                    role {\n                      id\n                      name\n                    }\n                    id\n                  }\n                  harvestProject {\n                    id\n                  }\n                  client {\n                    id\n                  }\n                  rateCard {\n                    id\n                    currency\n                    disabledRoles {\n                      id\n                    }\n                  }\n                  useTaskHierarchy\n                }\n                taskLabels {\n                  id\n                  label {\n                    id\n                    name\n                    color\n                  }\n                }\n                sprint {\n                  id\n                  endYear\n                  endMonth\n                  endDay\n                  savedPerformance\n                  name\n                  projectGroupSprintId\n                  isProjectGroupSprint\n                }\n                statusColumnV2 {\n                  id\n                  name\n                  category\n                  projectGroupStatusColumnId\n                }\n                phase {\n                  id\n                  name\n                  deadlineYear\n                  deadlineMonth\n                  deadlineDay\n                }\n                role {\n                  id\n                  name\n                }\n                assignedPersons {\n                  id\n                  active\n                  firstName\n                  lastName\n                  profilePictureId\n                  profilePictureDefaultId\n                  permissions\n                  client {\n                    id\n                  }\n                }\n                taskDismissedNotifications {\n                  taskOverrunPredictionDismissed\n                  id\n                }\n                thisTaskDependsOn(first: 1000) {\n                  edges {\n                    node {\n                      id\n                      type\n                      thisDependsOnTask {\n                        id\n                        name\n                        deadlineYear\n                        deadlineMonth\n                        deadlineDay\n                        startYear\n                        startMonth\n                        startDay\n                      }\n                      __typename\n                    }\n                    cursor\n                  }\n                  pageInfo {\n                    endCursor\n                    hasNextPage\n                  }\n                }\n                owner {\n                  id\n                  permissions\n                }\n                followers {\n                  id\n                  permissions\n                }\n                parentTask {\n                  id\n                  name\n                }\n                progressDetails {\n                  progress\n                  id\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          projectPersons(first: 1000000) {\n            edges {\n              node {\n                person {\n                  id\n                  active\n                  permissions\n                  firstName\n                  lastName\n                  fullName\n                  initials\n                  profilePictureId\n                  profilePictureDefaultId\n                  role {\n                    id\n                    name\n                  }\n                  client {\n                    id\n                  }\n                }\n                role {\n                  id\n                  name\n                }\n                id\n              }\n            }\n          }\n          sprints(first: 1000, onlyProjectGroupSprints: true) {\n            edges {\n              node {\n                id\n                name\n                projectGroupSprintId\n                isProjectGroupSprint\n                startDay\n                startMonth\n                startYear\n                endDay\n                endMonth\n                endYear\n                description @include(if: $fetchLazyData)\n                savedPerformance\n                hasUnfinishedTask\n                integrations {\n                  id\n                  jiraId\n                  adoId\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          phases(first: 1000) {\n            edges {\n              node {\n                id\n                name\n              }\n            }\n          }\n          statusColumnsV2(first: 1000000) {\n            edges {\n              node {\n                id\n                order\n                name\n                projectGroupStatusColumnId\n                jiraStatusId\n                category\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  project(internalId: $projectId) {\n    id\n    name\n    remainingAutoCalculated\n    tasks(first: 100000, approvedOnly: true, simpleResponse: true, backlog: true, context: \"sprint\") {\n      edges {\n        node {\n          id\n          readOnly {\n            isReadOnly\n            id\n          }\n          userCanDeleteTask\n          userCantDeleteTaskReason\n          hasChildren\n          sageIntacctId\n          name\n          description\n          highPriority\n          companyTaskId\n          hasNovaConversation\n          estimateForecast\n          timeLeft @include(if: $fetchLazyData)\n          timeRegistrations(first: 10000) @include(if: $fetchLazyData) {\n            edges {\n              node {\n                id\n                minutesRegistered\n                invoiced\n                person {\n                  id\n                  role {\n                    id\n                  }\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          progress @include(if: $fetchLazyData)\n          approved\n          sortOrder\n          blocked\n          bug\n          deadlineYear\n          deadlineMonth\n          deadlineDay\n          startYear\n          startMonth\n          startDay\n          startFrom\n          deadlineFrom\n          hasDependency\n          canStart\n          canBeSetToDone\n          subTaskCount\n          latestUiUpdateAt\n          hasLockedTime\n          hasInvoicedTime\n          favoured\n          billable\n          parentTaskId\n          taskLabels {\n            id\n            label {\n              id\n              name\n              color\n            }\n          }\n          sprint {\n            id\n            endYear\n            endMonth\n            endDay\n            name\n          }\n          statusColumnV2 {\n            id\n            name\n            category\n          }\n          phase {\n            id\n            name\n            deadlineYear\n            deadlineMonth\n            deadlineDay\n          }\n          role {\n            id\n            name\n          }\n          assignedPersons {\n            id\n            active\n            firstName\n            lastName\n            email\n            profilePictureId\n            profilePictureDefaultId\n            permissions\n            client {\n              id\n            }\n          }\n          taskDismissedNotifications {\n            taskOverrunPredictionDismissed\n            id\n          }\n          project {\n            id\n            name\n            demo\n            client {\n              id\n              name\n            }\n            harvestProject {\n              id\n            }\n            projectPerson(personId: $personId) {\n              role {\n                id\n                name\n              }\n              id\n            }\n            remainingAutoCalculated\n            companyProjectId\n            estimationUnit\n            minutesPerEstimationPoint\n            projectStartYear\n            projectStartMonth\n            projectStartDay\n            projectEndYear\n            projectEndMonth\n            projectEndDay\n            projectColor\n            stage {\n              __typename\n              id\n              name\n              profile\n            }\n            useTaskHierarchy\n          }\n          thisTaskDependsOn(first: 1000) {\n            edges {\n              node {\n                id\n                type\n                thisDependsOnTask {\n                  id\n                  name\n                  deadlineYear\n                  deadlineMonth\n                  deadlineDay\n                  startYear\n                  startMonth\n                  startDay\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          owner {\n            id\n            permissions\n          }\n          followers {\n            id\n            permissions\n          }\n          parentTask {\n            id\n            name\n          }\n          progressDetails {\n            progress\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    projectPersons(first: 1000000) {\n      edges {\n        node {\n          person {\n            id\n            active\n            permissions\n            firstName\n            lastName\n            fullName\n            initials\n            profilePictureId\n            profilePictureDefaultId\n            role {\n              id\n              name\n            }\n            client {\n              id\n            }\n          }\n          role {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n    sprints(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          timeLeft\n          forecast\n          startDay\n          startMonth\n          startYear\n          endDay\n          endMonth\n          endYear\n          description @include(if: $fetchLazyData)\n          savedPerformance\n          hasUnfinishedTask\n          sprintPersons(first: 1000000) {\n            edges {\n              node {\n                id\n                availableMinutes @include(if: $fetchLazyData)\n                scheduledMinutes @include(if: $fetchLazyData)\n                taskAvailableMinutes @include(if: $fetchLazyData)\n                person {\n                  id\n                  firstName\n                  lastName\n                  profilePictureId\n                  profilePictureDefaultId\n                  role {\n                    id\n                    name\n                  }\n                }\n              }\n            }\n          }\n          integrations {\n            id\n            jiraId\n            adoId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    phases(first: 1000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    statusColumnsV2(first: 1000000) {\n      edges {\n        node {\n          id\n          order\n          name\n          projectGroupStatusColumnId\n          jiraStatusId\n          category\n        }\n      }\n    }\n  }\n  company {\n    ...genericTaskContextMenu_company\n    id\n    backendId\n    name\n    currency\n    harvestEnabled\n    lockedPeriodYear\n    lockedPeriodMonth\n    lockedPeriodDay\n    isUsingProjectAllocation\n    modules {\n      moduleType\n      id\n    }\n    roles(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    labels(first: 1000000, labelType: TASK) {\n      edges {\n        node {\n          id\n          name\n          color\n          category {\n            id\n            name\n          }\n          ...LabelDropdownJS_labels\n        }\n      }\n    }\n    clients(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          logoId\n          logoDefaultId\n        }\n      }\n    }\n    teams(first: 1000000) {\n      edges {\n        ...TeamDropdown_teams\n        node {\n          id\n          name\n          teamPersons(first: 1000000) {\n            edges {\n              node {\n                id\n                person {\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    monday\n    tuesday\n    wednesday\n    thursday\n    friday\n    saturday\n    sunday\n  }\n}\n\nfragment TeamDropdown_teams on TeamTypeEdge {\n  node {\n    name\n    id\n  }\n}\n\nfragment genericTaskContextMenu_company on Company {\n  id\n  jiraCloudEnabled\n  jiraServerEnabled\n  integrations {\n    jiraCloud {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    jiraServer {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "90ceafe74b8e02dc4560940b785e44de";

export default node;
